import { Component, HostListener, Input } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
    selector: 'gl-option',
    templateUrl: './option.component.html',
    styleUrls: ['./option.component.scss'],
    standalone: false
})
export class OptionComponent {
  @Input() public value: any;
  @Input() public label: any;
  @Input() public loadType: boolean;
  public optionClicked = new Subject();

  @HostListener('click') public onclick() {
    this.optionClicked.next({
      component: this,
      text: this.label,
    });
  }

  public getOption() {
    return { component: this, text: this.label };
  }
}
